var __TEMP__ = require('./_castPath.js');var castPath = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isArguments.js');var isArguments = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isArray.js');var isArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_isIndex.js');var isIndex = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isLength.js');var isLength = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_toKey.js');var toKey = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = hasPath;
